type MinimumGridResolutionParams = {
  gridVolume: number | null;
  sensorPointLimit: number | null;
  volumeLimit: number | null;
  currentResolution: number;
  isResolutionUserDefined?: boolean;
  maximumResolution?: number;
};

const LARGE_GRID_VOLUME = 50_000;
const LARGE_GRID_DEFAULT_RESOLUTION = 3;

export function getGridResolutionWithinLimit({
  gridVolume,
  sensorPointLimit,
  volumeLimit,
  currentResolution,
  isResolutionUserDefined = false,
  maximumResolution = 20,
}: MinimumGridResolutionParams): number {
  const defaultResolution =
    !isResolutionUserDefined && gridVolume != null && gridVolume > LARGE_GRID_VOLUME
      ? LARGE_GRID_DEFAULT_RESOLUTION
      : 1;

  if (sensorPointLimit && sensorPointLimit === volumeLimit) return Math.max(currentResolution, defaultResolution);

  if (!gridVolume || !sensorPointLimit || gridVolume < 0 || sensorPointLimit < 0) {
    throw new Error('Missing grid volume or sensor point limit.');
  }

  const resolution = Math.max(1, Math.ceil(Math.cbrt(gridVolume / (sensorPointLimit * 1.05))));
  if (resolution > maximumResolution) {
    throw new Error('No grid resolution can satisfy the current sensor point limit.');
  }

  return Math.max(currentResolution, resolution, defaultResolution);
}
